import BarChartIcon from "@mui/icons-material/BarChart";
import DatasetIcon from "@mui/icons-material/Dataset";
import ValidationIcon from "@mui/icons-material/Checklist";
import ReportIcon from "@mui/icons-material/Description";

export const ABOUT_US_BLOCK_DATA = [
  {
    id: "graphs",
    title: "Interactive Graphs",
    subtitle: "Visualize your data with beautiful charts.",
    img: "/lovable-uploads/graphs_screen.png",
    Icon: BarChartIcon,
    color: "#9c27b0",
  },
  {
    id: "tables",
    title: "Complete Tables",
    subtitle: "Generate publication-ready tables with automatically drafted conclusions.",
    img: "/lovable-uploads/tables_screen.png",
    Icon: DatasetIcon,
    color: "#1976d2",
  },

  {
    id: "validations",
    title: "Automatic Validations",
    subtitle: "Automatic Data Validation- Validity, Completeness and Outliers",
    img: "/lovable-uploads/validation_screen.png",
    Icon: ValidationIcon,
    color: "#d32f2f",
  },
  {
    id: "reports",
    title: "Clear Reports",
    subtitle: "Automatically draft Statistical Methods and Results.",
    img: "/lovable-uploads/methods_results_screen.png",
    Icon: ReportIcon,
    color: "#388e3c",
  },
];
